const configFile = process.env.REACT_APP_ENV
const SERVER_URL = require('../'+configFile+'.js');
